export * from '@primeuix/themes/material/panel';
export { default } from '@primeuix/themes/material/panel';
